import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Row, Col, Button } from "react-bootstrap";
import moment from "moment-timezone";
import ChangePasswordPopup from "../ChangePasswordPopup";
import Alert from "../common/Alert";
import ToggleSwitch from "../common/ToggleSwitch";
import Radio from "../common/Radio";
import ChangeMobileNumberPopup from "../ChangeMobileNumberPopup";
import VerifyMobileNumberPopup from "../VerifyMobileNumberPopup";
import http from "../../api/http-request";
import ConfigureAuthenticatorPopup from "../ConfigureAuthenticatorPopup";
import { pageNotFound } from "../../utils/common";
import Checkbox from "../common/Checkbox";
import RenameDevicePopup from "../RenameDevicePopup";
import RemoveDevicePopup from "../RemoveDevicePopup";
import VerifyEmailAddressPopup from '../VerifyEmailAddressPopup';

class LoginAndSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPasswordPopup: false,
      showNumberPopup:false,
      preferredMode:"",
      showVerifyMobileNumberPopup:false,
      showConfigureAuthenticatorPopup:false,
      showRenameDevicePopup:false,
      showRemoveDevicePopup:false,
      showVerifyEmailPopup:false,
      deviceIdentifier:"",
      alias:"",
      responseData:{}
    };
  }
  componentDidUpdate =(props,state) =>{
    if(props.savedChanges !== this.props.savedChanges){
      this.savedChangesHandler(this.props.savedChanges)
      console.log(props,state,this.props)
    }
    if(props.disableMfa !== this.props.disableMfa){
      this.disableMfa(this.props.disableMfa);
    }
  }
  showChangePasswordPopup = () => {
    this.setState({
      showPasswordPopup: true
    });
  };
  showNumberPopup = () =>{
    this.setState({
      showNumberPopup:true
    })
  }

  onChangePasswordHandler = (status) => {
    const alertText =
      status === "success"
        ? "pages.changePasswordPopup.passwordChangeSuccessMsg"
        : "pages.changePasswordPopup.passwordChangeErrorMsg";
    this.setState(
      {
        showPasswordPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  onChangeNumberHandler = (status) =>{
    const alertText =
      status === "success"
        ? "pages.editNumberPopup.mobileChangeSuccessMsg"
        : "pages.editNumberPopup.mobileChangeErrorMsg";
    if (status === "success") {
      const { getUpdatedMobileNumber } = this.props;
      getUpdatedMobileNumber();
    }
    this.setState(
      {
        showNumberPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  }
  onErrorHandler = (status,message) => {
    let alertText = "";
    if(message === 'SMTP_ERROR'){
      alertText = "pages.editEmailAddressPopup.smtpError";
    }
    else if(message === 'MAX_RESEND_EXCEEDED'){
      alertText = "common.errors.maxResendAttempt";
    }
    else if(message === 'MAX_RETRY_EXCEEDED'){
      alertText = "pages.forgotUserName.maxVerifyAttempt";
    }
    else if(message === 'TWILIO_ERROR'){
      alertText = "common.errors.twilioError"
    }
    if(status === 'error'){
      this.setState(
        {
          alertStatus: status,
          showNumberPopup:false,
          showVerifyEmailPopup:false,
          alertText
        },
        () => {
          setTimeout(() => {
            this.setState({
              alertText: ""
            });
          }, 5000);
        }
      );
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
    }
  };
  onVerifyMobileNumberHandler= (status) => {
    const alertText =
      status === "success"
        ? "pages.editNumberPopup.verifyMobileChangeSuccessMsg"
        : "pages.editNumberPopup.mobileChangeErrorMsg";
    if (status === "success") {
      const { getVerifiedMobileNumber } = this.props;
      getVerifiedMobileNumber();
    }
    this.setState(
      {
        showVerifyMobileNumberPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  configuredAuthenticatorHandler= (status) => {
    const alertText =
      status === "success"
        ? "pages.profile.authSuccessMsg"
        : "pages.profile.authErrorMsg";
      if(status==="success"){
        this.props.getAppEnrolled(true);
      }
    this.setState(
      {
        showConfigureAuthenticatorPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  savedChangesHandler= (status) => {
    const alertText =
      status === "success"
        ? "pages.profile.savedChangesMsg"
        : "pages.profile.savedChangesErrorMsg";
      if(status==="success"){
        this.props.getAppEnrolled(false);
      }
    this.setState(
      {
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  showHideVerifyMobileNumberPopup = (value) =>{
    this.setState({
      showVerifyMobileNumberPopup:value
    })
  }
  configureAuthenticator = () =>{
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
    http({
      url:"authenticate?service=ProfileAuthenticatorRegistration&ForceAuth=true&authIndexType=service&authIndexValue=ProfileAuthenticatorRegistration",
      method:"POST"
    },
    {
      Authorization:`${bearer}${dataStoreToken}`,
      "Accept-API-Version": "protocol=1.0,resource=2.1"

    }).then((res)=>{
      if(res.status ===200 && res.data && res.data.callbacks){
        let splitCode;
        if(res.data.callbacks[0].output[0].value==='AUTHENTICATOR_PROMPT'){
          this.setState({
            showConfigureAuthenticatorPopup:true,
            // qrUrl:res.data.callbacks[2].output[0].value,
            // alphaNumericCode:splitCode[1],
            responseData:res.data
          })
        }
        
      }else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
    })
  }
  showHideAuthenticatorPopup = (value) =>{
    this.setState({
      showConfigureAuthenticatorPopup:value
    })
    
  }
  
  renameDeviceHandler = (device,alias) =>{
    this.setState({
      showRenameDevicePopup:true,
      deviceIdentifier:device,
      alias:alias
    })
  }
  removeDeviceHandler = (device) =>{
    this.setState({
      showRemoveDevicePopup:true,
      deviceIdentifier:device
    })
  }
  closeRenameHandler = () =>{
    this.setState({
      showRenameDevicePopup:false
    })
  }
  closeRemoveHandler = () =>{
    this.setState({
      showRemoveDevicePopup:false
    })
  }
  disableMfa = (status) =>{
    const alertText =
      status === "success"
        ? "pages.profile.verifyEmailPrompt"
        : "";
    this.setState(
      {
        alertStatus: "error",
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  }
  renameDevicePrompt= (status,username) => {
    const alertText =
      status === "success"
        ? "pages.profile.renamePromptSuccess"
        : "pages.profile.renamePromptError";
    if(status === "success"){
      this.props.getDeviceProfiles(username)
    }
    this.setState(
      {
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  removeDevicePrompt= (status,username) => {
    const alertText =
      status === "success"
        ? "pages.profile.removePromptSuccess"
        : "pages.profile.removePromptError";
    if(status === "success"){
      this.props.getDeviceProfiles(username)
    }
    this.setState(
      {
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  showHideVerifyEmailPopup = (value) =>{
    this.setState({
      showVerifyEmailPopup:value
    })
  }
  onVerifyEmailAddressHandler = (status) => {
    const alertText =
      status === "success"
        ? "pages.editEmailAddressPopup.emailVerifySuccessMsg"
        : "pages.editEmailAddressPopup.emailChangeErrorMsg";
    if (status === "success") {
      const { getUpdatedName } = this.props;
      getUpdatedName();
    }
    this.setState(
      {
        showVerifyEmailPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };
  render() {
    const { t, lastLoginTimestamp, userId,updatemfa,userData,modeChange,preferredMFAMode,saveMode,unConfigureAuthenticator,saveChanges,disableSave,cancelMfaPref, deviceProfile,mfa} = this.props;
    const { showPasswordPopup, alertStatus, alertText,showNumberPopup,showVerifyMobileNumberPopup,showConfigureAuthenticatorPopup,qrUrl,alphaNumericCode,responseData,showRenameDevicePopup,showRemoveDevicePopup,deviceIdentifier,alias,showVerifyEmailPopup} = this.state;
    const {mail,mfaEnrolled,telephoneNumber,phoneValidated,appEnrolled} = userData;
    return (
      <>
        {showPasswordPopup && (
          <ChangePasswordPopup
            userId={userId}
            onClose={() => {
              this.setState({ showPasswordPopup: false });
            }}
            onChangePasswordHandler={this.onChangePasswordHandler}
          />
        )}
        {alertText && (
          <Alert
            alertText={alertText}
            className={alertStatus}
            onAlertClose={() => {
              this.setState({
                alertText: ""
              });
            }}
          />
        )}
        {showNumberPopup && (
          <ChangeMobileNumberPopup
            userId={userId}
            onClose={() => {
              this.setState({ showNumberPopup: false });
            }}
            onChangeMobileNumberHandler={this.onChangeNumberHandler}
            onErrorHandler={this.onErrorHandler}
            telephoneNumber={telephoneNumber}
          />
        )}
        {showVerifyMobileNumberPopup && (
          <VerifyMobileNumberPopup
            onClose={() => this.showHideVerifyMobileNumberPopup(false)}
            onVerifyMobileNumberHandler={this.onVerifyMobileNumberHandler}
            telephoneNumber={telephoneNumber}
            onErrorHandler={this.onErrorHandler}
          />
        )}
        {showConfigureAuthenticatorPopup && (
          <ConfigureAuthenticatorPopup 
            onClose ={()=>this.showHideAuthenticatorPopup(false)}
            responseData={responseData}
            configuredAuthenticator={this.configuredAuthenticatorHandler}
            verifyAppEnrolled = {this.verifyAppEnrolledHandler}
          />
        )}
        {showRenameDevicePopup && (
          <RenameDevicePopup 
            identifier={deviceIdentifier}
            onClose={this.closeRenameHandler}
            userData = {userData}
            renameDevicePrompt = {this.renameDevicePrompt}
            alias={alias}
          />
        )}
        {showRemoveDevicePopup && (
          <RemoveDevicePopup 
            identifier={deviceIdentifier}
            onClose={this.closeRemoveHandler}
            userData = {userData}
            removeDevicePrompt={this.removeDevicePrompt}
          />
        )}
        {showVerifyEmailPopup && (
          <VerifyEmailAddressPopup
            onClose={() => this.showHideVerifyEmailPopup(false)}
            onVerifyEmailAddressHandler={this.onVerifyEmailAddressHandler}
            mail={userData.mail}
            onErrorHandler={this.onErrorHandler}
          />
        )}
        <div className={mfaEnrolled ? 'bold section-entry':'section-entry'}>
          <h2 className="page-heading">
            {t("pages.profile.loginAndSecurity")}
          </h2>
          <p className="page-desc">{t("pages.profile.loginAndSecurityDesc")}</p>
          <Row noGutters className="cards">
            <Col>
              <Row noGutters>
                <Col lg={{ span: 8 }}>
                  <h3 className="cards__title mb-2 mb-lg-0">
                    {t("pages.profile.accountAccess")}
                  </h3>
                </Col>
              </Row>
              <div className="cards__box">
                <Row noGutters className="cards__box-row finger-print-icon black">
                  <Col className="pass-section" xs={{ span: 4 }}>
                    <p className="cards__box-row-title">
                      {t("pages.profile.password")}
                    </p>
                  </Col>
                  <Col className="pass-section" xs={{ span: 4 }}>
                    <p className="cards__box-row-text">**********</p>
                  </Col>
                  <Col className="pass-section" xs={{ span: 4 }}>
                  <p
                    className="cards__box-row-link"
                    onClick={() => {
                      this.showChangePasswordPopup();
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyPress={() => {
                      this.showChangePasswordPopup();
                    }}
                    aria-label={t("pages.profile.ariaChangePassword")}
                  >
                    <span className="full">{t("pages.profile.changePassword")}</span>
                    <span className="short">{t("pages.editNumberPopup.update")}</span>
                  </p>
                </Col>
                </Row>
                <Row noGutters className="cards__box-row login-activity-icon black">
                  <Col xs={{ span: 4 }}>
                    <p className="cards__box-row-title">
                      <span className="full">{t("pages.profile.loginActivity")}</span>
                      <span className="short">{t("pages.profile.shortActivity")}</span>
                    </p>
                  </Col>
                  <Col xs={{ span: 8 }}>
                    <p className="cards__box-row-text">
                      <span className="full">{t("pages.profile.lastLoginOn")}</span>
                      <span className="short">{t("pages.profile.shortLastLogin")}</span>
                      <span className="date-stamp">
                        {lastLoginTimestamp
                          ? moment(lastLoginTimestamp, ["YYYYMMDDHHmmssZ"])
                              .tz("America/New_York")
                              .format("MM/DD/YYYY hh:mm A")
                          : "--"}
                      </span>
                    </p>
                  </Col>
                </Row>
                <Row noGutters className={mfaEnrolled ? "cards__box-row mfa-enrolled-icon enrolled black" : "cards__box-row mfa-enrolled-icon black"}>
                  <Col lg={{ span: 4 }} className=" d-flex align-items-center">
                    <p className="cards__box-row-title">
                      {t("pages.profile.mfaAuthentication")}
                    </p>
                  </Col>
                  <Col lg={{ span: 4 }} className="second-col">
                    <div className="switchToggler d-flex">
                      <ToggleSwitch 
                        name="mfaToggle"
                        isChecked={mfaEnrolled}
                        handleChange={updatemfa}
                        label={`MFA ${mfaEnrolled? t("pages.profile.enabled"): t("pages.profile.disabled")}`}
                      />
                      <span>{mfaEnrolled ? t("pages.profile.enabled") : t("pages.profile.disabled")}</span>
                    </div>
                  </Col>
                  <Col lg={{span:4}} className="third-col">
                    {userData.emailValidated === "false" && <a className="cards__box-row-link" href="javascript:void(0)" role="button" onClick={()=>this.showHideVerifyEmailPopup(true)}>{t("pages.editEmailAddressPopup.verifyEmailAddress")}</a>}
                    {userData.emailValidated === "true" && <a className="cards__box-row-link" href="https://portal.ct.gov/ctidentity/mfa-faq?language=en_US" target="_blank">{t("pages.login.learnMoreMFA")}</a>}
                  </Col>
                </Row>
                {saveChanges && <div className="save-change-msg short"> <p>
                      {t("pages.profile.saveChangesMsg")}
                </p></div>}
                {mfaEnrolled && (
                  <>
                    <p className="cards__box-row-title mfa-settings-heading">{t("pages.profile.mfaSettings")}</p>
                    <Row noGutters className="cards__box-row mfa-settings">
                      <Col lg={{span:12}}>
                        <Row noGutters className="mfaEmail preferredChoice">
                          <Col xs={{span:4}}>
                            <Radio 
                              name="OptMFA"
                              label={"pages.profile.optEmail"}
                              value="EMAIL"
                              isChecked={preferredMFAMode === "EMAIL" ? true :false}
                              handleChange={modeChange}
                            />
                          </Col>
                          <Col lg={{span:4}} xs={{span:8}} className="second-col">
                            <p className="cards__box-row-text">{mail}</p>
                          </Col>
                        </Row>
                        <Row noGutters className="mfaSms preferredChoice">
                          <Col lg={{span:4}} xs={{span:8}}>
                            <Radio 
                              name="OptMFA"
                              label={"pages.login.prefSms"}
                              value="SMS"
                              isChecked={preferredMFAMode === "SMS" ? true :false}
                              handleChange={modeChange}
                              disabled={phoneValidated === "true" ? false :true}
                            />
                          </Col>
                          <Col lg={{span:4}} xs={{span: 6}} className="second-col">
                            {telephoneNumber ? (<p className="cards__box-row-text">{telephoneNumber}</p>): (<p className="cards__box-row-text light">{t("pages.profile.none")}</p>)}
                          </Col>
                          <Col lg={{span:4}} xs={{span: 6}} className="third-col">
                            {phoneValidated !== "true" ? (telephoneNumber ? (<a className="cards__box-row-link" href="javascript:void(0)" role="button" onClick={()=>this.showHideVerifyMobileNumberPopup(true)}>{t("pages.editNumberPopup.verifyNumber")}</a>):(<a className="add-number cards__box-row-link" href="javascript:void(0)" role="button" onClick={this.showNumberPopup} aria-label={t("pages.profile.ariaAddText")}>{t("pages.profile.addPhoneNumber")}</a>)):""}
                          </Col>
                        </Row>
                        <Row noGutters className="mfaPhone preferredChoice">
                          <Col lg={{span:4}} xs={{span:8}}>
                            <Radio 
                              name="OptMFA"
                              label={"pages.login.phoneChoice"}
                              value="CALL"
                              isChecked={preferredMFAMode === "CALL" ? true :false}
                              handleChange={modeChange}
                              disabled={phoneValidated === "true" ? false :true}
                            />
                          </Col>
                          <Col lg={{span:4}} xs={{span: 6}} className="second-col">
                            {telephoneNumber ?(<p className="cards__box-row-text">{telephoneNumber}</p>): (<p className="cards__box-row-text light">{t("pages.profile.none")}</p>)}
                          </Col>
                          <Col lg={{span:4}} xs={{span: 6}} className="third-col">
                            {phoneValidated !== "true" ? (telephoneNumber ? (<a className="cards__box-row-link" href="javascript:void(0)" role="button" onClick={()=>this.showHideVerifyMobileNumberPopup(true)}>{t("pages.editNumberPopup.verifyNumber")}</a>):(<a className="add-number cards__box-row-link" href="javascript:void(0)" role="button" onClick={this.showNumberPopup} aria-label={t("pages.profile.ariaAddPhone")}>{t("pages.profile.addPhoneNumber")}</a>)):""}
                          </Col>
                        </Row>
                        <Row noGutters className="mfaAuthenticator preferredChoice">
                          <Col lg={{span:4}} xs={{span:8}}>
                            <Radio 
                              name="OptMFA"
                              label={"pages.login.authenticateChoice"}
                              value="AUTHENTICATOR"
                              isChecked={preferredMFAMode === "AUTHENTICATOR" ? true :false}
                              handleChange={modeChange}
                              disabled={appEnrolled === "true" ? false :true}
                            />
                          </Col>
                          <Col lg={{span:4}} xs={{span: 6}} className="second-col">
                            {appEnrolled === "true" ?(<p className="cards__box-row-text">{t("pages.profile.configured")}</p>): (<p className="cards__box-row-text light">{t("pages.profile.none")}</p>)}
                          </Col>
                          <Col lg={{span:4}} xs={{span: 6}} className="third-col">
                            {appEnrolled === "true" ? (<a className="add-number cards__box-row-link" href="javascript:void(0)" role="button" onClick={()=>unConfigureAuthenticator(false)}>{t("pages.profile.unConfigure")}</a>): (<a className="add-number cards__box-row-link" href="javascript:void(0)" role="button" onClick={this.configureAuthenticator} aria-label={t("pages.profile.ariaSetAuthenticator")}>{t("pages.profile.setup")}</a>)}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}
                {saveChanges && <Row noGutters className="save-changes">
                  <Col md={{ span: 3 }} className="submit-btn cancel">
                    <Button
                      size="lg"
                      variant="primary"
                      type="submit"
                      onClick={cancelMfaPref}
                    >
                      {t("pages.profile.cancel")}
                    </Button>
                  </Col> 
                  <Col md={{span:6}}>
                    {saveChanges && <div className="save-change-msg full"> <p>
                      {t("pages.profile.saveChangesMsg")}
                    </p></div>}
                  </Col>
                  <Col md={{ span: 3 }} className="submit-btn save">
                    <Button
                      size="lg"
                      variant="primary"
                      type="submit"
                      onClick={saveMode}
                      disabled={disableSave}
                    >
                      {t("pages.profile.save")}
                    </Button>
                  </Col>
                </Row>}
                {mfa && deviceProfile.length > 0 && <Row noGutters className="cards__box-row login-device-icon">
                  <Col lg={{ span: 4 }}>
                    <p className="cards__box-row-title">
                      {t("pages.profile.trustedDevice")}
                    </p>
                  </Col>
                  <Col lg={{span:4}} className="second-col">
                    <p className="cards__box-row-text">{t("pages.profile.configured")}</p>
                  </Col>
                </Row>}
                {mfa && deviceProfile.length > 0 && deviceProfile.map((device) =>{
                  return(
                    <Row noGutters className="cards__box-row mfa-settings trusted-device-settings" key={device.identifier}>
                      <Col lg={{span:12}}>
                        <Row noGutters className="trustedChoice">
                          <Col xs={{span:4}}>
                            <p className="device">{device.alias}</p>
                          </Col>
                          <Col xs={{span:4}} className="second-col">
                            <p className="cards__box-row-link float-left" onClick={()=>this.renameDeviceHandler(device.identifier,device.alias)} onKeyPress={()=>this.renameDeviceHandler(device.identifier)} tabIndex={0} role="button">{t("pages.profile.rename")}</p>
                          </Col>
                          <Col xs={{span:4}} className="third-col">
                            <p className="cards__box-row-link float-left" onClick={()=>this.removeDeviceHandler(device.identifier)} onKeyPress={()=>this.removeDeviceHandler(device.identifier)} tabIndex={0} role="button">{t("pages.profile.remove")}</p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )
                })}
                
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

LoginAndSecurity.propTypes = {
  t: PropTypes.func.isRequired,
  lastLoginTimestamp: PropTypes.string,
  userId: PropTypes.string.isRequired
};
LoginAndSecurity.defaultProps = {
  lastLoginTimestamp: ""
};
export default withTranslation()(LoginAndSecurity);
